import { useMemo } from 'react';
import { NearbyActivityRadius } from 'core/entities/user/user-configuration';
import { useSelector } from 'react-redux';
import { selectNearbyActivityRadius } from 'store/selectors/app-selectors';
import { useReportPlaces } from 'extensions/widget/hooks/use-poi-hooks';
import type { PlacerEntityModel, Venue } from '@placer-ui/types';

export const useNearbyActivityRadius = (): NearbyActivityRadius | undefined =>
    useSelector(selectNearbyActivityRadius);

export const useNearbyActivityRadiusOptions = (): number[] | undefined => {
    const nearbyActivityRadius = useNearbyActivityRadius();
    return nearbyActivityRadius?.options;
};

export const useNearbyActivityRadiusDefault = (): number => {
    const nearbyActivityRadius = useNearbyActivityRadius();
    return nearbyActivityRadius?.default || 250;
};

export const useGetNearbyFtRadiusPois = () => {
    const nearbyActivityRadiusOptions = useNearbyActivityRadiusOptions();
    const { all: allEntities } = useReportPlaces();
    const poisWithFtRadius: PlacerEntityModel<Venue>[] = useMemo(
        () =>
            allEntities?.filter(
                (entity) =>
                    nearbyActivityRadiusOptions?.length && entity.filters?.config?.ft_radius,
            ) || [],
        [allEntities, nearbyActivityRadiusOptions],
    );

    return poisWithFtRadius;
};
